import React from 'react';

/**
 * Operator ruling 2026-10-25 A (docs/PRODUCT_DECISIONS.md "Pay page when the company cannot take
 * online payments", #6211): a company that cannot take online payments gets no Pay button and no
 * Stripe notices; the customer sees "How to pay" with the company's Payment instructions
 * (company_settings.payment_instructions), or "Please contact <company> to arrange payment." when
 * none are set. One owner for the rule and the block, used by every portal surface that offers
 * to pay an invoice: the pay page (PayInvoice.js), the signed-in Invoices page (Invoices.js) and
 * the quote/job portal's bottom bar (Portal/ActionsBar.js).
 */

/** "Can take online payments" = companies.stripe_onboarding_complete (kept in sync with Stripe
 *  by stripe-connect-status / stripe-webhook). */
export const companyCanPayOnline = (company) => !!company?.stripe_onboarding_complete;

const HowToPay = ({
  instructions,
  companyName,
  className = 'bg-gray-50 rounded-lg p-4',
  titleClassName = 'font-medium text-gray-900 mb-2',
  textClassName = 'text-sm text-gray-700',
}) => {
  const text = String(instructions || '').trim();
  return (
    <div className={className} data-testid="how-to-pay">
      <p className={titleClassName}>How to pay</p>
      {text ? (
        <p className={`${textClassName} whitespace-pre-line`} data-testid="pay-invoice-instructions">
          {text}
        </p>
      ) : (
        <p className={textClassName}>
          Please contact {companyName || 'the company'} to arrange payment.
        </p>
      )}
    </div>
  );
};

export default HowToPay;
